<template>
   <v-layout column>
      <TopToolBar
         title="Usuários"
      ></TopToolBar>

      <div
         v-if="loading"
         class="text-center mt-8"
      >
         <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <div
         v-if="!loading && !error"
         class="sessions"
      >
         <v-card
            v-if="users.length"
            class="mx-auto my-4"
            max-width="500"
         >
            <v-list
               two-line
               class="pa-0"
            >
               <template
                  v-for="(user, index) in users"
               >
                  <v-list-item
                     :key="user.id"
                  >
                     <v-list-item-avatar>
                        <v-img
                           :src="user.profile_photo_url || '/img/default.png'"
                        ></v-img>
                     </v-list-item-avatar>

                     <v-list-item-content>
                        <v-list-item-title>
                           {{ user.name }}
                        </v-list-item-title>

                        <v-list-item-subtitle>
                           {{ user.email }}
                        </v-list-item-subtitle>
                     </v-list-item-content>

                     <v-list-item-action
                        v-if="user.admin"
                     >
                        <v-list-item-action-text>
                           <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                 <span v-on="on">
                                    <v-icon>admin_panel_settings</v-icon>
                                 </span>
                              </template>
                              <span>Administrador</span>
                           </v-tooltip>
                        </v-list-item-action-text>
                     </v-list-item-action>

                     <v-list-item-action
                        v-if="user.in_vacation"
                     >
                        <v-list-item-action-text>
                           <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                 <span v-on="on">
                                    <v-icon>beach_access</v-icon>
                                 </span>
                              </template>
                              <span>De férias</span>
                           </v-tooltip>
                        </v-list-item-action-text>
                     </v-list-item-action>
                  </v-list-item>

                  <v-divider
                     v-if="index < users.length - 1"
                     :key="index"
                  ></v-divider>
               </template>
            </v-list>
         </v-card>

         <div
            v-if="users.length === 0"
            class="mt-4 text-center text-h6 text--secondary"
         >
            Nenhum usuário encontrado
         </div>
      </div>

      <v-alert
         class="mt-4 mx-auto text-center"
         max-width="400"
         text
         type="error"
         v-if="error"
      >
         <p>
            Não foi possível carregar os usuários
         </p>

         <v-btn
            @click="getUsers"
            color="primary"
         >
            Tentar novamente
         </v-btn>
      </v-alert>
   </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TopToolBar from "@/pages/CustomerServiceRasa/pages/components/TopToolBar";

export default {
   components: {
      TopToolBar,
   },

   computed: {
      ...mapGetters('rasaUsers', [
         'error',
         'loading',
         'userList',
      ]),

      users() {
         return [...this.userList].sort((a, b) => a.name.localeCompare(b.name));
      },
   },

   methods: {
      ...mapActions('rasaUsers', [
         'getUsers',
      ]),
   },
};
</script>

<style lang="scss"></style>
